// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1n4uW","productName":"Table_productName__3j5qt"};